import { type ComponentProps, useId, useMemo } from 'react';
import { cn } from '@/shared/lib/cn';
import { useFormFieldName } from './form-field-context';
import { FormItemContext } from './form-item-context';

export function FormItem({ className, ...props }: ComponentProps<'div'>) {
  const id = useId();
  const name = useFormFieldName();
  const value = useMemo(() => ({ id, name }), [id, name]);
  return (
    <FormItemContext.Provider value={value}>
      <div data-slot="form-item" className={cn('flex flex-col gap-2.5', className)} {...props} />
    </FormItemContext.Provider>
  );
}
